<template>
  <q-select
    ref="select"
    :options="filteredTimezones"
    :model-value="modelValue"
    :outlined="outlined"
    :dense="dense"
    :error="error"
    :loading="loading"
    :hint="hint"
    hide-bottom-space
    map-options
    emit-value
    option-value="zone"
    option-label="zone"
    error-message="Invalid timezone"
    @update:model-value="(val) => $emit('update:modelValue', val)"
    @focus="refreshOptions"
  >
    <template #option="scope">
      <q-item
        v-bind="scope.itemProps"
      >
        <q-item-section>
          <q-item-label :class="{'text-bold': scope.selected}">
            {{ scope.opt.zone }}
          </q-item-label>
          <q-item-label caption>
            {{ scope.opt.diff_from_gmt }}
          </q-item-label>
        </q-item-section>
      </q-item>
    </template>
    <template #after-options>
      <div
        class="sticky-position blurred-container q-px-md"
        style="bottom: 0;"
      >
        <q-checkbox
          v-model="showAllTimezones"
          label="Show All Timezones"
          @update:model-value="refreshOptions"
        />
      </div>
    </template>
  </q-select>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: null
    },
    outlined: {
      default: false,
      type: Boolean
    },
    dense: {
      default: false,
      type: Boolean
    },
    error: {
      default: false,
      type: Boolean
    },
    hint: {
      type: String
    }
  },
  emits: ['update:modelValue'],
  data () {
    return {
      loading: false,
      showAllTimezones: false,
      timezones: this.$store.getters.getSystemSetting('timezones')
    }
  },
  computed: {
    filteredTimezones () {
      if (!this.showAllTimezones) {
        return this.timezones.filter(item => {
          return item.zone.includes('Australia')
        })
      }
      return this.timezones
    }
  },
  methods: {
    refreshOptions () {
      setTimeout(() => {
        this.$refs.select.refresh()
      }, 0)
    }
  }
}
</script>
